
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionChronology2019() {
  return (
    <>
      <div className="section section-dark gradient-background-claro" style={{ paddingBottom: "0px" }} >

        <Container className="tim-container">

          <div className="title">
            <h3>2019</h3>
          </div>

          <div id="typography">
            <Row>


              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > Early August </span>
                  Up to this point, 25 chars were already made with the hqx algorithm.
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > 6th August </span>
                  First comparisons of the sprites obtained from the HQX algorithm with the new sprites edited with AI and image editors by BobNostalgic.
                  Starting to test with BobNostalgic.
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="First comparisons with the sprites obtained from the hqx algorithm with the new sprites made with AI and img editors by BobNostalgic."
                      src={require("assets/img/Development/NS_1er.jpg")}
                    />
                  </Col>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="Nightwolf Sprites in img editors by BobNostalgic. They had a better graphic quality than the sprites obtained from the hqx algorithm but they weren't compatible with palettes."
                      src={require("assets/img/Development/NS_2do.jpg")}
                    />
                  </Col>
                </Row>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > 8th August </span>
                  First successful adaptation of the palettes used with the hqx algorithm sprites to the new sprites.
                  <Row style={{ width: "100%", marginTop: "20px" }}>
                    <Col xs="12" sm="6">
                      <img
                        style={{ cursor: 'pointer' }}
                        width="100%"
                        alt="First successful adaptation of the palettes used with the hqx algorithm sprites to the new sprites made in img editors."
                        src={require("assets/img/Development/NS_3er.jpg")}
                      />
                    </Col>
                    <Col xs="12" sm="6">
                      <img
                        style={{ cursor: 'pointer' }}
                        width="100%"
                        alt="First chars with compatible palettes and with the new sprites edited in img editors."
                        src={require("assets/img/Development/NS_4to.jpg")}
                      />
                    </Col>
                  </Row>
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > 12th August </span>
                  Leaving everything advanced so far with the sprites altered with the HQX algorithm
                  and starting to produce everything again but using the new sprites.
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > November </span>
                  The project was stopped and work with Bob Nostalgic was discontinued. With the new sprites, the demand for time and effort was very high, and maintaining optimal
                  communication was very difficult, so we decided to go our separate ways. <br />
                  Up to this point, 12 chars had been remastered with BoBNostalgic using the method implemented up to that date.
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > 1th of December </span>
                  Starting to study new tools in image editors to better adapt the palettes and thus reduce work time.
                  This in turn have the sprites a bit more sharpness.
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="Final tests. Up to this point the palettes were easier to work with and the sprites a bit sharper."
                      src={require("assets/img/Development/NS_5to.jpg")}
                    />
                  </Col>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="Final tests. Up to this point the palettes were easier to work with and the sprites a bit sharper."
                      src={require("assets/img/Development/NS_6to.jpg")}
                    />
                  </Col>
                </Row>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > 7th of December </span>
                  Leaving everything advanced so far, and starting to produce everything again adding what
                  was learned in image editors to better adapt the palettes and reduce work time. <br />
                  From this point on, the remastered chars that will be placed in the final game begin to be produced.
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > December 28th </span>
                  Scripts developed to automatically perform part of the work, saving a lot of time and effort.
                  Starting to produce new chars with remastered sprites much faster and with less work.
                </p>
              </div>

            </Row>
          </div>

        </Container>
      </div>
    </>
  );
}

export default SectionChronology2019;
